import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
    return {
        hasInteracted: state.sound.hasInteracted,
        musicEnabled: state.sound.musicEnabled,
        activeMusicSource: state.sound.activeMusicSource,
        musicSource: state.sound[ownProps.componentName]
    }
}

const MusicPlayer = ({ componentName, hasInteracted, activeMusicSource, musicSource, musicEnabled }) => {
    const [volume, setVolume] = useState(0)
    const [isActive, setIsActive] = useState(false)
    const audioRef = useRef(null)
    useEffect(() => {
        if (audioRef.current) {
            // NOTE: Browser will not autoplay audio without user interaction
            if (hasInteracted) {
                if (componentName === activeMusicSource) {
                    if (audioRef.current.paused) {
                        setVolume(0)
                        setIsActive(true)
                    }
                } else if (audioRef.current.play) {
                    setIsActive(false)
                }
            }
        }
    }, [componentName, activeMusicSource, hasInteracted])

    useEffect(() => {
        let fadeInterval = null
        if (audioRef.current) {
            if (!musicEnabled) {
                audioRef.current.currentTime = 0
                audioRef.current.volume = 0
                audioRef.current.pause()
            } else if (isActive && musicEnabled) {
                audioRef.current.currentTime = 0
                audioRef.current.volume = 0
                audioRef.current.play()
                if (fadeInterval) {
                    clearInterval(fadeInterval)
                }
                fadeInterval = setInterval(() => {
                    let currentVolume = audioRef.current.volume + Math.min(volume + 0.1, 1.0)
                    if (currentVolume >= 1.0) {
                        clearInterval(fadeInterval)
                    } else {
                        audioRef.current.volume = currentVolume
                    }
                }, 50)
            } else if (audioRef.current.play) {
                if (fadeInterval) {
                    clearInterval(fadeInterval)
                }
                fadeInterval = setInterval(() => {
                    let currentVolume = audioRef.current.volume + Math.min(volume - 0.05, 0)
                    if (currentVolume <= 0) {
                        audioRef.current.currentTime = 0
                        audioRef.current.pause()
                        clearInterval(fadeInterval)
                    } else {
                        audioRef.current.volume = currentVolume
                    }
                }, 50)
            }
        }
        return () => {
            if (fadeInterval) {
                clearInterval(fadeInterval)
            }
        }
    }, [isActive, musicEnabled])

    return (
        <div className="music-player">
            <audio
                ref={audioRef}
                src={musicSource}
                loop={true}
                autoPlay={true}
            />
        </div>
    )
}

export default connect(mapStateToProps)(MusicPlayer)
